import * as React from 'react';
import Spinner from './spinner';
import ErrorMessage from './error_message';

class Loading extends React.Component {
  render() {
    if (!this.props.loaded) { return <Spinner size={this.props.size} color={this.props.color} />; }
    if (this.props.hasError) { return <ErrorMessage message={this.props.errorMessage} />; }

    return <div className="loaded-component">{this.props.children}</div>;
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./javascripts/components/shared/loading.jsx